import styles from './Content.module.css';
const Content = (props) => {
    return (<div class={styles.content}>
      <div class={styles.body}>{props.children}</div>
    </div>);
};
export default Content;
